import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./Bussinessdash.css"
import { AiOutlineCloseSquare } from "react-icons/ai";
import { localUrl, url } from "../../../src/component/env";


export const Userdash = (props) => {
  const { loading, data } = useSelector((state) => state.planData);
let barererToken = "Bearer " + localStorage.getItem("access_token");

  //all ads count
  console.log("!!!data", data);
  const [business, setBusiness] = useState(true)

  const [allAdsCount, setAllAdsCount] = useState({});
  const [staticLoader, setStaticLoader] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showPopup1, setShowPopup1] = useState(false);
  const [showPopup3, setShowPopup3] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [adde, setAdde] = useState([]);

  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", barererToken);
  
    var formdata = new FormData();
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
  
    fetch(url + "api/user/adsby/", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result, "Amit");
        setAdde(result);
      })
      .catch((error) => console.log("error", error));
  }, []);
  
//   useEffect(()=>{
//     // const apiResult = { verified: true };
//     var formdata = new FormData();
// formdata.append("userid", "58");

// var requestOptions = {
//   method: 'POST',
//   body: formdata,
//   redirect: 'follow'
// };

// fetch("https://hola9.live/api/adsapi/checkBusinessPlan", requestOptions)
//   .then(response => response.json())
//   .then(result => {
//     setBusiness(result.businessPlan)
//     console.log(result,"resvar")
//   })
//   .catch(error => console.log('error', error));
//   },[])

  return (
    <div>
      
                      <div className="col-md-8 col-sm-12 col-xs-12">
                        {loading ? (
                            <div className="w-100 d-flex justify-content-center h-100 align-items-center bg-dark text-center ">
                            <div class="loader "></div>
                          </div>
                        ) : (
                          <>
                            <div>
                              <div
                                style={{
                                  background: "rgb(92, 151, 170)",
                                  borderRadius: "5px",
                                }}
                              >
                                  <div className="row ad-history" >
                                    <div className="Usertable col-lg-12">
                                      <div className="user-stats pb-0">
                                        <div className="inlineAds text-white">
                                        <table className="table" style={{width:"15cm"}}>
                    <thead>
                      <th className="text-white py-0 pl-0">Ads Types</th>
                      <th className="text-white py-0 pl-0">Ads Posted</th>
                      <th className="text-white py-0 pl-0">Ads Left</th>
                      <th className="text-white py-0 pl-0">Plans Validity</th>
                      <th className="text-white py-0 pl-0">Ads Category</th>
                      <th className="text-white py-0 pl-0">Posted by</th>
                      <th className="text-white py-0 pl-0">Expiry</th>
                    </thead>
                    <tbody>
                      {data.hasOwnProperty("planDataDetails") &&
                        Object?.keys(data?.planDataDetails)?.map((result) => {
                         if(result === "Platinum"){
                            return (
                              <tr>
                                {/* <td className="m-0 p-0" onClick={() => setShowPopup(true)}>{result}</td> */}
                                
                                <td className="m-0 p-0">
                                 
                                  <tr  onClick={() => setShowPopup(true)} className="poptr" >Premium</tr>
                                  <tr  onClick={() => setShowPopup2(true)} className="poptr" >Featured</tr>
                                </td>
                                <td className="m-0 p-0">
                                 
                                  <tr className="m-0 p-0">
                                    {
                                      data?.planDataDetails[result]["PostedTopAds"]
                                    }
                                  </tr>
                                  <tr className="m-0 p-0">
                                    {
                                      data?.planDataDetails[result]["PostedFeaturedAds"]
                                    }
                                  </tr>
                                </td>
                                <td className="m-0 p-0">
                                  
                                  <tr className="m-0 p-0">
                                    {
                                      data?.planDataDetails[result]["leftTopAds"]
                                    }
                                  </tr>
                                  <tr>
                                    {
                                      data?.planDataDetails[result]["leftFeaturedAds"]
                                    }
                                  </tr>
                                </td>
                                <td className="m-0 p-0">
                                <tr>
                                    {data?.postAdsForm[result]["days"]} Days
                                </tr>
                                <tr>
                                    {data?.postAdsForm[result]["days"]} Days
                                </tr>
                              </td>
                              </tr>
                            );
                          }
                        })}
                    </tbody>
                  </table>{showPopup && (
                                      <div className="popup" >
                                        <div>
                                          <button
                                            onClick={() => setShowPopup(false)}
                                            style={{
                                              float: "right",
                                              color: "white",
                                              marginTop: '-15px',
                                              fontSize: '20px',

                                            }}
                                          >
                                            <AiOutlineCloseSquare />
                                          </button>
                                        </div>
                                        <br></br>
                                        <div>
                                        <table className="table ">
                    <thead>
                      <th className="text-white py-0 pl-0">Ads Types</th>
                      <th className="text-white py-0 pl-0">Ads Category</th>
                      <th className="text-white py-0 pl-0">Posted Date</th>
                      <th className="text-white py-0 pl-0">Expire Date</th>
                    </thead>
                    <tbody>
                      {data.hasOwnProperty("planDataDetails") &&
                        Object?.keys(data?.planDataDetails)?.map((result) => {
                          if(result === "Platinum")
                            return (
                              <tr>
                              
                                <td className="m-0 p-0" onClick={() => setShowPopup(true)}>Premium</td>
                                
                               
                                <td className="m-0 p-0">
                                {adde.map((addes) => {
                                if (addes.fields.adsType === "TopAds" && addes.fields.is_active===true) {
                                  return <tr>{addes?.fields?.category}</tr>;
                                }
                                return null;
                              })}
                                 
                                </td>
                             
                                <td className="m-0 p-0">
                                {adde.map((addes) => {
                                if (addes.fields.adsType === "TopAds" && addes.fields.is_active===true) {
                                  return <tr>{addes?.fields?.date_created}</tr>;
                                }
                                return null;
                              })}
                                </td>
                             
                                <td className="m-0 p-0">
                                {adde.map((addes) => {
                                if (addes.fields.adsType === "TopAds" && addes.fields.is_active===true) {
                                  return <tr>{addes?.fields?.date_expire}</tr>;
                                }
                                return null;
                              })}

                                </td>

                             
                              </tr>
                            );
                          
                        })}
                    </tbody>
                  </table>
                                        </div>
                                      </div>
                                    )}
                                    {showPopup2 && (
                                      <div className="popup" >
                                        <div>
                                          <button
                                            onClick={() => setShowPopup2(false)}
                                            style={{
                                              float: "right",
                                              color: "white",
                                              marginTop: '-15px',
                                              fontSize: '20px',

                                            }}
                                          >
                                            <AiOutlineCloseSquare />
                                          </button>
                                        </div>
                                        <br></br>
                                        <div>
                                        <table className="table">
                    <thead>
                      <th className="text-white py-0 pl-0">Ads Types</th>
                      <th className="text-white py-0 pl-0">Ads Category</th>
                      <th className="text-white py-0 pl-0">Posted Date</th>
                      <th className="text-white py-0 pl-0">Expire Date</th>
                    </thead>
                    <tbody>
                      {data.hasOwnProperty("planDataDetails") &&
                        Object?.keys(data?.planDataDetails)?.map((result) => {
                          if(result === "Platinum" ){
                            return (
                              <tr>
                               
                                <td className="m-0 p-0" onClick={() => setShowPopup(true)}>Featured</td>
                                
                               
                                <td className="m-0 p-0">
                                 
                                {adde.map((addes) => {
                                if (addes.fields.adsType === "Featured" && addes.fields.is_active===true) {
                                  return <tr>{addes?.fields?.category}</tr>;
                                }
                                return null;
                              })}
                                 
                                </td>
                             
                                <td className="m-0 p-0">
                                {adde.map((addes) => {
                                if (addes.fields.adsType === "Featured" && addes.fields.is_active===true) {
                                  return <tr>{addes?.fields?.date_created}</tr>;
                                }
                                return null;
                              })}

                                </td>
                             
                                <td className="m-0 p-0">
                                {adde.map((addes) => {
                                if (addes.fields.adsType === "Featured" && addes.fields.is_active===true) {
                                  return <tr>{addes?.fields?.date_expire}</tr>;
                                }
                                return null;
                              })}

                                </td>

                             
                              </tr>
                            );
                          }
                        })}
                    </tbody>
                  </table>
                                        </div>
                                      </div>
                                    )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                          </>
                        )}
                      </div>
                      {/* <UserDashPlanDetails/> */}
                    </div>
  );
};

export default Userdash;
